// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

// Use named rather than default exports.
const MemberStatus = dynamic(() => import('./MemberStatus').then(mod => mod.MemberStatus));

export const MemberStatusConfig = {
  emptyLabel: 'memberStatus',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/memberStatus`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MemberStatusEditable = (props: any) => {
  return props.cqPath.includes('datapagecomponent') ? (
    <MemberStatus {...props} />
  ) : (
    <EditableComponent config={MemberStatusConfig} {...props}>
      <MemberStatus {...props} />
    </EditableComponent>
  );
};
